export enum SvgIcon {
  Account = 1,
  Basket,
  Facebook,
  Google,
  Instagram,
  Linkedin,
  Pinterest,
  TikTok,
  Web,
  Youtube,
}
